import { types } from 'mobx-state-tree'

const ResourceCommentModel = types.model('ResourceCommentModel', {
  comment: types.maybeNull(types.string),
  commentDateTime: types.maybeNull(types.string),
  moderatorFullName: types.maybeNull(types.string),
})

export default ResourceCommentModel
